import $ from 'jquery';
import { viewport } from './Viewport';
import CalendarFeed from './CalendarFeed';
import DDTemplates from './DDTemplates';
import Anchors from './Anchors';
import Drupal from './Drupal';
import FixNavigation from './FixNavigation';
import Gallery from './Gallery';
import GallerySlider from './GallerySlider';
import Header from './Header';
import HomeEvents from './HomeEvents';
import MicrositeEvents from './MicrositeEvents';
// Homepage functionality
import HeroSlider from './HeroSlider';
import HeroVideo from './HeroVideo';
import HomeQuotes from './HomeQuotes';
import Messages from './Messages';
import Modaal from './Modaal';
import Navigation from './Navigation';
// import Parallax from './Parallax';
import SmartFooter from './SmartFooter';
import Sticky from './Sticky';
import TermNavigation from './TermNavigation';
import Toolbar from './Toolbar';
// Communities Template functionality
import Communities from './Communities';
// Communities nearest me
import ProximityController from './ProximityController';
import { E } from 'keyboard-key';
import Timeline from './Timeline';
import EventsSlider from './EventsSlider';

// Add a detach function to jQuery
(function($) {
  if (!$.fn.detach) {
    $.fn.detach = function() {
      return this.each(function() {
        if(this.parentNode) {
          this.parentNode.removeChild( this );
        }
      });
    };
  }
}(jQuery));

// Add the theme behaviors
Drupal.behavior((context) => {

  // After Footer links
  const finePrint = document.querySelector('.page-footer .fine-print');
  const afterFooter = document.querySelector('.page-footer .after-footer-links');
  const parentDiv = afterFooter ? afterFooter.parentNode : null;
  const viewContent = afterFooter ? afterFooter.querySelector('.view-content') : null;
  
  if (afterFooter) {
    parentDiv.insertBefore(afterFooter, finePrint);
    const newViewsRow = document.createElement('div');
    newViewsRow.classList.add("views-row");
    const thisYear = new Date().getFullYear();
    newViewsRow.insertAdjacentHTML('afterbegin', `Copyright © ${thisYear} O'Connor Woods`);
    viewContent.insertAdjacentElement('afterbegin', newViewsRow);
  }

  // Copy Hero CTA to header for mobile sticky functionality
  const micrositeCommunities = document.querySelector('body.front');
  if (micrositeCommunities) {
    const elementToCopy = document.querySelector('.node-microsite-hero .node-header');
    if (elementToCopy) {
      const targetParent = document.querySelector('.page-header');
      const clonedElement = elementToCopy.cloneNode(true);
      targetParent.appendChild(clonedElement);
    }
  }

  // Move mobile CTA to header for mobile sticky functionality (subpages and mobile only)
  const micrositeCommunitiesSubpage = document.querySelector('body.not-front');
  if (micrositeCommunitiesSubpage) {
    const elementMobileCTA = document.querySelector('.microsite-mobile-cta');
    const targetParentHeader = document.querySelector('.page-header');
    if (elementMobileCTA && targetParentHeader) {
      targetParentHeader.appendChild(elementMobileCTA);
    }
  }

  // Move microsite hero title to flickity-viewport
  const micrositeHeroSection = document.querySelector('.microsite-hero');

  if (micrositeHeroSection) {
    const heroTitleElement = micrositeHeroSection.querySelector('.node-header h1');
    const heroSubTitleElement = micrositeHeroSection.querySelector('.node-header h2');

    const titleWrapper = createAndAddClass('div', 'microsite-hero__title-wrapper');
    const titleElement = createAndAddClass('div', 'microsite-hero__title');
  
    const flickityViewport = micrositeHeroSection.querySelector('.flickity-viewport');
  
    appendChildElements(flickityViewport, [titleWrapper]);
    appendChildElements(titleWrapper, [titleElement]);

    if (heroSubTitleElement) {
      appendChildElements(titleElement, [heroSubTitleElement, heroTitleElement]);
    } else {
      appendChildElements(titleElement, [heroTitleElement]);
    }
  }

  function createAndAddClass(elementType, className) {
    const element = document.createElement(elementType);
    element.classList.add(className);
    return element;
  }
  
  function appendChildElements(parent, children) {
    children.forEach(child => parent.insertAdjacentElement('afterbegin', child));
  }

  // Get microsite title and create logo style
  const bodyElement = document.body;
  if (bodyElement.classList.contains('microsite-communities')) {
    const pageClass = Array.from(bodyElement.classList).find((className) => className.includes('microsite-'));

    if (pageClass) {
      const removePagePrefix = str => str.replace('microsite-', '');
      const logoUrl = `/sites/main/files/misc/${removePagePrefix(pageClass)}.svg`;

      const setLogoStyle = (selector, url) => {
        const logoElement = document.querySelector(selector);
        if (logoElement) {
          logoElement.setAttribute('style', `background-image: url('${url}');`);
        }
      };

      const setLogoUrl = (selector) => {
        const logoElement = document.querySelector(selector);
        if (logoElement) {
          logoElement.setAttribute('href', `/${removePagePrefix(pageClass)}`);
        }
      };

      setLogoStyle('.primary-navigation li:first-child a', logoUrl);
      setLogoStyle('.microsite-branding .mobile-logo', logoUrl);
      setLogoUrl('.microsite-branding .logo a');
    }
  }

  // AM / PM add space + periods
  const calendarDates = document.querySelectorAll('.date-display-single .date-display-start, .date-display-single .date-display-end, .event-date-tile .time');
  if (calendarDates) {
    calendarDates.forEach(e => e.textContent = e.textContent.replace('am', ' a.m.').replace('pm', ' p.m.'));
  }

  $('body').append('<div class="warning-indicators" hidden></div>');

  $('.node-home-hero', context).each((i, element) => {
    if (!element.heroSlider) {
      element.heroSlider = new HeroSlider(element);
      $('#page-title').remove();
    }
  });

  // Hero Banner with Video
  // $('.home__hero .node-home-hero .flickity-slider .has-video', context).each((i, element) => {
  //   if (!element.HeroVideo) {
  //     element.HeroVideo = new HeroVideo(element);
  //   }
  // });

  // Hero Slider Microsite
  $('.node-microsite-hero', context).each((i, element) => {
    if (!element.heroSlider) {
      element.heroSlider = new HeroSlider(element);
      $('#page-title').remove();
    }
  });

  // Messages
  $('#messages', context).each((i, element) => {
    const isError = element.querySelector('.messages.error');
    if (!element.Messages && isError) {
      element.Messages = new Messages(element);
    }
  });

  // DD Template Behaviors
  if (!document.body.DDTemplates) {
    document.body.DDTemplates = new DDTemplates(context);
  }

  // Fix our damn menus from displaying orphaned children
  $('.main-navigation, .term-navigation', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  /**
   * Communities Template Specific
   */
  if (document.body.classList.contains('ttv-std-4') && !document.body.Communities) {
    document.body.Communities = new Communities();
  }

  // Parallax effect for Home Hero and Banner images.
  // $('.home__hero, .banner', context).find('img:not(.wave)').each((i, element) => {
  //   if (!element.Parallax) {
  //     element.Parallax = new Parallax(element);
  //   }
  // });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main Navigation
  $('#nice-menu-3', context).each((i, element) => {
    if (!element.Navigation) {
      element.Navigation = new Navigation(element);
    }
  });

  // Controls the states of the menu and search states
  $('.toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Fixed Header using Headroom.js
  $('.headroom', context).each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Smart Footer
  // $('body:not(.microsite):not(.ttveskaton-community) .page-footer', context).each((i, element) => {
  //   if (!element.SmartFooter) {
  //     const $reactiveElement = $('.page', context);
  //     element.SmartFooter = new SmartFooter(element, $reactiveElement);
  //   }
  // });

  // Term Navigation
  $('.term-navigation', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Homepage Upcoming Events
  // $('.home__events:not(.placeholder-block)', context).each((i, element) => {
  //   if (!element.HomeEvents) {
  //     element.HomeEvents = new HomeEvents(element);
  //   }
  // });

  // Homepage Testimonials/Quotes
  $('.home__quotes', context).each((i, element) => {
    if (!element.HomeQuotes) {
      element.HomeQuotes = new HomeQuotes(element);
    }
  });

  // Replace Lightbox lightframe functionality with Modaal.
  $('.open-lightframe', context).each((i, element) => {
    if (!element.Modaal) {
      const selector = '.node-header a, .field-image a, .link-read-more a';
      element.Modaal = new Modaal(element, selector);
    }
  });

  // Replace Lightbox slideshow functionality with Modaal.
  $('.te-open-slideshow .node, .te-open-slideshow.node', context).each((i, element) => {
    if (!element.Modaal) {
      const selector = '.field-image a';
      element.Modaal = new Modaal(element, selector);
    }
  });

  // Replace Lightbox and Lighframe straggelers.
  $('[rel^=lightbox], [rel^=lightframe]', context).closest('.node').each((i, element) => {
    const notValid = element.parentNode.classList.contains('dd-hover-dependencies');
    if (!element.Modaal && !notValid) {
      // const selector = '.node-header a, .field-image a, .link-read-more a';
      const selector = '.field-image a';
      element.Modaal = new Modaal(element, selector);
    }
  });

  // Enable video modal on communities resources teasers.
  setTimeout(() => {
    $('.communities__resources .node.play-video', context).each((i, element) => {
      if (!element.resourcesModaal) {
        const selector = '.node-header a';
        element.resourcesModaal = new Modaal(element, selector);
      }
    });
  }, 200);

  // Photo Galleries
  $('body:not(.microsite) .node-content .photo-gallery, body:not(.microsite) .photo-gallery .node-image, body:not(.microsite) .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // Gallery Slider
  $('.microsite-carousel-gallery .node-image', context).each((i, element) => {
    if (!element.GallerySlider) {
      element.GallerySlider = new GallerySlider(element);
    }
  });

  $('.microsite-events .view-content', context).each((i, element) => {
    if (!element.eventsSlider) {
      element.eventsSlider = new EventsSlider(element);
    }
  });

  // Home Event Slider
  $('.home__events', context).each((i, element) => {
    if (!element.HomeEvents) {
      element.HomeEvents = new HomeEvents(element);
    }
  });

  // Microsite Event Slider
  $('.upcoming__events', context).each((i, element) => {
    if (!element.MicrositeEvents) {
      element.MicrositeEvents = new MicrositeEvents(element);
    }
  });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element);
    }
  });

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }

  // Add Anchor management
  if (!document.body.Anchors) {
    document.body.Anchors = new Anchors();
  }

  // Geofield Form Controller
  $('form#proximity-geofield', context).each((i, element) => {
    if (!element.ProximityController) {
      element.ProximityController = new ProximityController(element);
    }
  });

  // Timeline
  $('body.page-our-history-and-timeline', context).each((i, element) => {
    if (!element.Timeline) {
      element.Timeline = new Timeline(element);
    }
  });

  // function addPadding(test) {
  //   $(test).each((i, element) => {
  //     var $header = $('header.page-header .header');
  //     var $nav = $('#navigation');
  //     var $flyout = $('.page-header #flyout.flyout');
  //     var $search = $('.page-header #flyout.flyout .site-search');
  //     var $sidebar = $('main.page-main .page-sidebar.sticky');
  //     var $section = $('main.page-main .page-center');
  //     $(element).detach().prependTo('body');
  //     const elemHeight = $(element).outerHeight(false);
  //     if ($(element).not('.cc-invisible').length > 0) {
  //       $nav.css('top', (parseInt($nav.css('top')) + elemHeight) + 'px');
  //       $header.css('top', (parseInt($header.css('top')) + elemHeight) + 'px');
  //       $flyout.css('top', (parseInt($flyout.css('top')) + elemHeight) + 'px');
  //       if ($(window).width() > 1024) {
  //         $search.css('top', (parseInt($search.css('top')) + elemHeight) + 'px');
  //       }
  //       $sidebar.css('top', (parseInt($sidebar.css('top')) + elemHeight) + 'px');
  //       $section.css('padding-top', (parseInt($section.css('padding-top')) + elemHeight) + 'px');
  //     }
  //     $(element).find('.cc-dismiss').click(function () {
  //       $nav.css('top', (parseInt($nav.css('top')) - elemHeight) + 'px');
  //       $header.css('top', (parseInt($header.css('top')) - elemHeight) + 'px');
  //       $flyout.css('top', (parseInt($flyout.css('top')) - elemHeight) + 'px');
  //       if ($(window).width() > 1024) {
  //         $search.css('top', (parseInt($search.css('top')) + elemHeight) + 'px');
  //       }
  //       $sidebar.css('top', (parseInt($sidebar.css('top')) + elemHeight) + 'px');
  //       $section.css('padding-top', (parseInt($section.css('padding-top')) - elemHeight) + 'px');
  //       $(this).addClass('cc-invisible');
  //     });
  //   });
  // }

  $('body', context).each(() => {
    var title = $('h1#page-title');
    if (title.length > 1) {
      title.each((i,element) => {
        var $element = $(element);
        if ($element.hasClass('default')) {
          $element.remove();
        }
      });
    }
  });

  // Links with new tab or new frame.
  $('a[target="_blank"]', context).each((i, element) => {
    var $element = $(element);
    var warningIndicator = 'Opens an external site in a new window';

    if ($element.hasClass('video-lightframe')) {
      warningIndicator = 'Opens video in a new frame';
    }

    $element.attr('aria-describedby', `warning-indicator-${i}`);
    $('.warning-indicators').append(`<span id="warning-indicator-${i}">${warningIndicator}</span>`);
  });

  // function addPadding(cookie) {
  //   setTimeout(() => {
  //     const cookieVisible = $(cookie).not('.cc-invisible');
  //     const microsite = $('body.microsite');
  //     if (cookieVisible) {
  //       let topCookie = cookieVisible.outerHeight();
  //       let topPad = $('.page').css('padding-top');
  //       topPad = parseInt(topPad);
  //       let newPadding = topPad + topCookie;
  //       // if (!microsite.length > 0) {
  //       //   $('header.page-header').css('top', topCookie + 'px');
  //       // }
  //       // $('.page').css('padding-top', newPadding + 'px');
  //     }
  //   }, 400);
  // }
  // addPadding('.cc-window.cc-top.fixed-top');
  
  // Update Viewport
  viewport.update();

  // Read More ADA
  const articles = document.querySelectorAll('article');
  articles.forEach(e => {
    const articleTitleLink = e.querySelector('.title a');
    const articleTitle = articleTitleLink ? articleTitleLink.innerText : '';
    const readmoreTitleDiv = e.querySelector('.readmore-title');
    const readmoreTitle = readmoreTitleDiv ? readmoreTitleDiv.innerText : false;
    const readmoreButton = e.querySelector('li.link-read-more a');
    if (readmoreTitle && readmoreButton) {
      readmoreButton.setAttribute('aria-label', readmoreTitle);
      readmoreButton.setAttribute('title', readmoreTitle);
    } else if(readmoreButton) {
      readmoreButton.setAttribute('aria-label', 'Read more about ' + articleTitle);
      readmoreButton.setAttribute('title', 'Read more about ' + articleTitle);
    }
  });

  // Add label to search input
  const searchInput = document.querySelector('#edit-keywords-wrapper');
  if (searchInput) {
    const newLabel = document.createElement('Label');
    const newContent = document.createTextNode("Search");
    newLabel.setAttribute('for', 'edit-keywords');
    newLabel.classList.add('visuallyhidden');
    newLabel.appendChild(newContent);
    searchInput.insertAdjacentElement('afterbegin', newLabel);
  }

  // const isMicrosite = document.querySelector('body.microsite');
  // const isEskatonCommunity = document.querySelector('body.ttveskaton-community');
  // const communitiesOverview = document.querySelector('.communities__overview');
  // const amplifyWidget = document.querySelector('.amplify-widget');
  // if (amplifyWidget && !isMicrosite && !communitiesOverview && !isEskatonCommunity) {
  //   const nodeContent = document.querySelector('.node-content');
  //   nodeContent.insertAdjacentElement('beforeend', amplifyWidget);
  // }

  // Add aria-label to inputs inside "field-embed label"
  window.onload = function () {
    const testLabel = document.querySelectorAll('.field-embed label');
    if (testLabel) {
      testLabel.forEach((e) => {
        const labelInput = e.querySelector('input');
        if (labelInput) {
          labelInput.setAttribute('aria-label', e.textContent);
          e.parentElement.setAttribute('aria-label', e.textContent);
        }
      });
    }

    const ulCheckboxes = document.querySelectorAll('[role="checkbox"]');
    if (ulCheckboxes) {
      ulCheckboxes.forEach((e) => {
        e.setAttribute('aria-label', 'Checkbox');
      });
    }

    const typeSubmit = document.querySelectorAll('input[type="submit"]');
    if (typeSubmit) {
      typeSubmit.forEach((e) => {
        e.setAttribute('aria-label', 'Submit');
      });
    }

    const selectOperator = document.querySelectorAll('.form-select');
    if (selectOperator) {
      selectOperator.forEach((e) => {
        e.setAttribute('aria-label', e.getAttribute('title'));
      });
    }

    const loginPopup = document.querySelectorAll('.dd-login');
    if (loginPopup) {
      loginPopup.forEach((e) => {
        e.setAttribute('aria-label', 'Login popup dialog');
      });
    }

    // Select All links and add aria-label
    const links = document.querySelectorAll('a');
    if (links) {
      links.forEach((e) => {
        if (e.hasAttribute('aria-label') || e.hasAttribute('title') || e.hasAttribute('role')) {
          return;
        }
        e.setAttribute('aria-label', e.textContent.trim());
      });
    }

    // Add span element to pagination text
    const allPagers = document.querySelectorAll('li.pager-first a, li.pager-previous a, li.pager-next a, li.pager-last a');
    if (allPagers) {
      allPagers.forEach(e => {
        const node = e.childNodes[0];
        const span = document.createElement('span');
        node.after(span);
        span.appendChild(node);
      });
    }

    // Add time to events on calendar page
    const eventDateWrap = document.querySelectorAll('body.page-calendar time.start');
    if (eventDateWrap) {
      eventDateWrap.forEach(e => {
        const dateTime = new Date(e.getAttribute('datetime')).toLocaleTimeString('en-US', { hour: "2-digit", minute: "2-digit" }).toLowerCase().replace('am', ' a.m.').replace('pm', ' p.m.');
        e.insertAdjacentHTML('beforeend', `<div class="time">${dateTime}</div>`);
      });
    }
  }

  // Add phone number on "live well at home" microsite primary navigation
  const primaryNav = document.querySelector('.microsite-388 .primary-navigation #nice-menu-3');
  if (primaryNav) {
    primaryNav.insertAdjacentHTML('beforeend', '<li class="even last depth-1"><a href="tel:8004781209" title="" class="menu-link depth-1"><span class="menu-title">800-478-1209</span></a></li>');
  }

  // Display footer with same id as body microsite-id
  function applyStyleToMicrositeFooter() {
    const pattern = /microsite-(\d+)/;
    let desiredNumber = null;
    const micrositeElement = document.querySelector('.microsite');

    if (micrositeElement) {
      Array.from(micrositeElement.classList).some(className => {
        const match = className.match(pattern);
        if (match) {
          desiredNumber = match[1];
          return true;
        }
        return false;
      });
  
      if (desiredNumber) {
        const micrositeFooter = document.querySelectorAll(`.microsite-footer article.t${desiredNumber}`);
        micrositeFooter.forEach(e => {
          e.style.display = 'block';
        });
      }
    }
  }
  applyStyleToMicrositeFooter();

});
